import sample from 'lodash.sample'
import React from 'react'
import {Box, Skeleton, Stack} from '@chakra-ui/react'

const FIRST_NAME_SIZES = [8, 12, 16, 20]
const LAST_NAME_SIZES = [16, 20, 24, 32, 40]

export function FanListSkeleton() {
  return (
    <Box bg="white" borderRadius="md" boxShadow="sm">
      <Stack
        alignItems="center"
        borderBottom="1px solid"
        borderBottomColor="gray.100"
        direction="row"
        mx={4}
        py={4}
        spacing="auto"
      >
        <Skeleton h={4} w={12} />
        <Skeleton h={8} w={24} />
      </Stack>
      {Array.from(Array(8).keys()).map((i) => (
        <Stack alignItems="center" direction="row" key={i} px={4} py={2}>
          <Skeleton h={12} w={12} />
          <Stack>
            <Skeleton h={4} w={sample(FIRST_NAME_SIZES)} />
            <Skeleton h={4} w={sample(LAST_NAME_SIZES)} />
          </Stack>
        </Stack>
      ))}
    </Box>
  )
}
